import Checkbox from '@cobliteam/colib-ui/Checkbox';
import Label from '@cobliteam/colib-ui/Label';
import { Typography } from '@cobliteam/ui/components';
import type { MultipleSurveyQuestion } from 'posthog-js';

interface Props {
  question: MultipleSurveyQuestion;
  value?: string[];
  onChange: (value: string[]) => void;
  hideTitle?: boolean;
}

const QuestionMultipleChoice = ({ question, value, onChange, hideTitle = false }: Props) => {
  const choices = question.choices ?? [];
  const selected = value ?? [];

  const toggle = (choice: string, checked: boolean) => {
    if (checked) {
      onChange([...selected, choice]);
    } else {
      onChange(selected.filter((c) => c !== choice));
    }
  };

  return (
    <div className='flex flex-col gap-3'>
      {!hideTitle && (
        <Typography variant='text-md' className='font-medium'>
          {question.question}
        </Typography>
      )}
      {question.description ? <Typography variant='text-sm'>{question.description}</Typography> : null}
      <div className='flex flex-col gap-2'>
        {choices.map((choice, idx) => {
          const id = `mchoice-${idx}`;
          return (
            <div key={choice} className='flex items-center gap-2'>
              <Checkbox id={id} checked={selected.includes(choice)} onCheckedChange={(checked) => toggle(choice, Boolean(checked))} />
              <Label htmlFor={id}>{choice}</Label>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuestionMultipleChoice;
